import {message, Select} from "../../../../__snowpack__/pkg/antd.js";
import {isFunction} from "../../../../__snowpack__/pkg/lodash.js";
import React, {useState} from "../../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
const MESSAGE_KEY = "tags-input";
export default function TagsInput(props) {
  const {formatMessage} = useIntl();
  const {
    maxLength = 100,
    maxTagCount = 3,
    maxTagTextLength = maxLength,
    maxLengthMessage = formatMessage({id: "theMaximumLengthIsCharacters"}, {maxLength}),
    value,
    onChange,
    onSelect,
    ...restProps
  } = props;
  const [inputValue, setInputValue] = useState("");
  return /* @__PURE__ */ React.createElement(Select, {
    maxTagCount,
    maxTagTextLength,
    mode: "tags",
    open: false,
    allowClear: true,
    inputValue,
    onSearch: (_inputValue) => {
      if (_inputValue.length > maxLength) {
        const messageContent = isFunction(maxLengthMessage) ? maxLengthMessage(maxLength) : maxLengthMessage;
        message.warn({content: messageContent, key: MESSAGE_KEY});
      }
      setInputValue(_inputValue.slice(0, maxLength));
    },
    onSelect: (...args) => {
      setInputValue("");
      onSelect?.(...args);
    },
    value: [...new Set(value?.map((item) => item.trim())?.filter((item) => !!item))],
    onChange: (_value) => {
      onChange?.([...new Set(_value?.map((item) => item.trim())?.filter((item) => !!item))]);
    },
    ...restProps
  });
}
